import ApiRequest from "../../utils/api-request";

const PROMO_CODE_MODE = {
    PERCENTAGE: 'percentage',
    AMOUNT: 'amount'
}

const state = {
    bikes: [],
    tours: [],
    events: [],
    accessories: [],
    merchandises: [],
    additionalOptions: [],
    promoCode: null
}

const actions = {
    // BIKES
    addBike: (context, item) => {
        if (context.state.tours.length > 0 || context.state.events.length >= 1) {
            context.commit('SET_TOURS', [])
            context.commit('SET_EVENTS', []);
        }

        if (item.item.discount > 0 && context.state.promoCode !== null) {
            context.commit('REMOVE_PROMO_CODE');
            return 2;
        }

        context.commit('ADD_BIKE', item);
        return 0;
    },
    removeBike: (context, index) => {
        context.commit('REMOVE_BIKE', index);
    },
    //TOURS
    addTour: (context, item) => {
        if (context.state.bikes.length > 0 || context.state.tours.length >= 1 || context.state.events.length >= 1) {
            context.commit('SET_BIKES', []);
            context.commit('SET_TOURS', []);
            context.commit('SET_EVENTS', []);
        }
        context.commit('ADD_TOUR', item);
        return true;
    },
    removeTour: (context, index) => {
        context.commit('REMOVE_TOUR', index);
    },
    //EVENTS
    addEvent: (context, item) => {
        if (context.state.bikes.length > 0 || context.state.tours.length >= 1) {
            context.commit('SET_BIKES', []);
            context.commit('SET_TOURS', []);
        }
        context.commit('ADD_EVENT', item);
        return 0;
    },
    removeEventBike: (context, index) => {
        context.commit('REMOVE_EVENT_BIKE', index);
    },
    // ACCESSORIES
    addAccessory: (context, item) => {
        context.commit('ADD_ACCESSORY', item);
    },
    removeAccessory: (context, index) => {
        context.commit('REMOVE_ACCESSORY', index);
    },
    // MERCHANDISES
    addMerchandise: (context, item) => {
        context.commit('ADD_MERCHANDISE', item);
    },
    removeMerchandise: (context, index) => {
        context.commit('REMOVE_MERCHANDISE', index);
    },
    // ADDITIONAL OPTIONS
    addAdditionalOption: (context, item) => {
        context.commit('ADD_ADDITIONAL_OPTION', item);
    },
    removeAdditionalOption: (context, index) => {
        context.commit('REMOVE_ADDITIONAL_OPTION', index);
    },
    usePromoCode: async (context, promoCode) => {
        /** If there are discounted bikes in cart */
        // if (context.getters.bikes.filter(bike => (bike.item.discount > 0)).length) {
        //     return false;
        // }

        let response = await new ApiRequest().getDiscount(promoCode);

        if (response.data.status) {
            context.commit('ADD_PROMO_CODE', response.data.discount);
        }
        return response;
    },
    clearPromoCode: (context) => {
        context.commit('REMOVE_PROMO_CODE');
    },
    clear: (context) => {
        context.commit('SET_BIKES', []);
        context.commit('SET_TOURS', []);
        context.commit('SET_EVENTS', []);
        context.commit('SET_ACCESSORIES', []);
        context.commit('SET_MERCHANDISES', []);
        context.commit('SET_ADDITIONAL_OPTIONS', []);
        context.commit('ADD_PROMO_CODE', null);
    }
}

const mutations = {
    // BIKES
    SET_BIKES: (state, value) => {
        state.bikes = value;
    },
    ADD_BIKE: (state, item) => {
        let bike = state.bikes.findIndex(bike => (bike.id === item.id && bike.priceOption.price_id === item.priceOption.price_id))
        if (bike !== -1) {
            state.bikes[bike].amount += item.amount;
        } else {
            state.bikes.push(item);
        }
    },
    REMOVE_BIKE: (state, index) => {
        state.bikes.splice(index, 1);
    },
    // TOURS
    SET_TOURS: (state, value) => {
        state.tours = value;
    },
    ADD_TOUR: (state, item) => {
        state.tours.push(item);
    },
    REMOVE_TOUR: (state, index) => {
        state.tours.splice(index, 1);
    },
    // EVENTS
    SET_EVENTS: (state, value) => {
        state.events = value;
    },
    ADD_EVENT: (state, item) => {
        let bike = state.events.findIndex(bike => (bike.id === item.id && bike.priceOption.price_id === item.priceOption.price_id))
        if (bike !== -1) {
            state.events[bike].amount += item.amount;
        } else {
            state.events.push(item);
        }
    },
    REMOVE_EVENT_BIKE: (state, index) => {
        state.events.splice(index, 1);
    },
    // ACCESSORIES
    SET_ACCESSORIES: (state, value) => {
        state.accessories = value;
    },
    ADD_ACCESSORY: (state, item) => {
        state.accessories.push(item);
    },
    REMOVE_ACCESSORY: (state, index) => {
        state.accessories.splice(index, 1);
    },
    // MERCHANDISES
    SET_MERCHANDISES: (state, value) => {
        state.merchandises = value;
    },
    ADD_MERCHANDISE: (state, item) => {
        state.merchandises.push(item);
    },
    REMOVE_MERCHANDISE: (state, index) => {
        state.merchandises.splice(index, 1);
    },
    // ADDITIONAL OPTIONS
    SET_ADDITIONAL_OPTIONS: (state, value) => {
        state.additionalOptions = value;
    },
    ADD_ADDITIONAL_OPTION: (state, item) => {
        state.additionalOptions.push(item);
    },
    REMOVE_ADDITIONAL_OPTION: (state, index) => {
        state.additionalOptions.splice(index, 1);
    },
    // COMMON
    ADD_PROMO_CODE: (state, value) => {
        state.promoCode = value;
    },
    REMOVE_PROMO_CODE: (state) => {
        state.promoCode = null;
    }
}

const getters = {
    // BIKES
    bikes: (state) => state.bikes,
    bikesNumber: (state) => {
        return state.bikes.map(item => item.amount).reduce((total, i) => total + i, 0);
    },
    bikeIsInCart: (state) => (id, typeRental) => {
        if(typeRental === 'events') {
            return state.events.findIndex(x => x.item.id === id) !== -1;
        } else {
            return state.bikes.findIndex(x => x.item.id === id) !== -1;
        }
    },
    bikesTotalPrice: (state) => {
        return state.bikes.reduce((res, item) => {
            return res + ((state.promoCode ? item.priceOption.price : item.priceOption.final_price) * item.amount);
        }, 0);
    },
    bikesTotalInsurance: (state) => {
        return state.bikes.reduce((res, item) => {
            return res + (item.insuranceAmount * item.item.insurance);
        }, 0);
    },
    bikesTax: (state, getters, rootState, rootGetters) => {
        return (getters.bikesTotalPrice - ((state.promoCode && state.promoCode.mode === PROMO_CODE_MODE.PERCENTAGE) ? getters.bikesTotalPrice * state.promoCode.amount : 0)) * (getters.taxValue / 100);
    },
    // TOURS
    tours: (state) => state.tours,
    toursTotalPrice: (state) => {
        return state.tours.reduce((res, item) => {
            return res + ((state.promoCode ? item.item.price : item.item.final_price) * item.item.bike_types.reduce((total, i) => total + i.amount, 0) * item.amount);
        }, 0);
    },
    toursTotalInsurance: (state) => {
        return state.tours.reduce((res, item) => {
            return res + item.item.bike_types.reduce((total, i) => {
                return total + (i.insuranceAmount * i.bike_type.insurance);
            }, 0)
        }, 0);
    },
    toursTax: (state, getters, rootState, rootGetters) => {
        return 0;
    },
    // events
    events: (state) => state.events,
    eventBikesNumber: (state) => {
        return state.events.map(item => item.amount).reduce((total, i) => total + i, 0);
    },
    eventBikesTotalPrice: (state) => {
        return state.events.reduce((res, item) => {
            return res + ((state.promoCode ? item.priceOption.price : item.priceOption.final_price) * item.amount);
        }, 0);
    },
    eventBikesTotalInsurance: (state) => {
        return state.events.reduce((res, item) => {
            return res + (item.insuranceAmount * item.item.insurance);
        }, 0);
    },
    eventBikesTax: (state, getters, rootState, rootGetters) => {
        return (getters.eventBikesTotalPrice - ((state.promoCode && state.promoCode.mode === PROMO_CODE_MODE.PERCENTAGE) ? getters.eventBikesTotalPrice * state.promoCode.amount : 0)) * (getters.taxValue / 100);
    },
    // ACCESSORIES
    accessories: (state) => state.accessories,
    accessoriesTotalPrice: (state) => {
        return state.accessories.reduce((res, item) => {
            return res + (item.priceOption.price * item.amount);
        }, 0);
    },
    accessoriesTax: (state, getters, rootState, rootGetters) => {
        return 0;
    },
    // MERCHANDISES
    merchandises: (state) => state.merchandises,
    merchandisesTotalPrice: (state) => {
        return state.merchandises.reduce((res, item) => {
            return res + (item.priceOption.price * item.amount);
        }, 0);
    },
    merchandisesTax: (state, getters, rootState, rootGetters) => {
        return 0;
    },
    // ADDITIONAL OPTIONS
    additionalOptions: (state) => state.additionalOptions,
    additionalOptionsTotalPrice: (state) => {
        return state.additionalOptions.reduce((res, item) => {
            return res + (item.item.additional_option_location_prices.price * item.amount);
        }, 0);
    },
    additionalOptionsTax: (state, getters, rootState, rootGetters) => {
        let taxFreeItems = ['insurance'];
        let sum = state.additionalOptions.filter(ao => !taxFreeItems.includes(ao.item.slug)).reduce((res, item) => {
            return res + (item.item.additional_option_location_prices.price * item.amount);
        }, 0);
        return (sum - ((state.promoCode && state.promoCode.mode === PROMO_CODE_MODE.PERCENTAGE) ? sum * state.promoCode.amount : 0)) * (getters.taxValue / 100);
    },
    // COMMON
    isEmpty: (state, getters) => {
        if (getters.totalNumber < 1) {
            state.bikes = [];
            state.events = [];
            state.tours = [];
            state.accessories = [];
            state.additionalOptions = []
            state.promoCode = null;
            return true;
        }
        return false;
    },
    taxValue: (state, getters, rootState, rootGetters) => {
        if (getters.bikes.length && rootGetters['filter/rentLocation']) {
            return rootGetters['app/locations'].find(i => i.id === rootGetters['filter/rentLocation']).tax;
        }
        return rootGetters['app/settings'].location.tax;
    },
    totalNumber: (state) => {
        return state.bikes.length + state.tours.length + state.events.length;
    },
    totalPrice: (state, getters) => {
        return getters.bikesTotalPrice +
            getters.bikesTotalInsurance +
            getters.eventBikesTotalPrice +
            getters.eventBikesTotalInsurance +
            getters.toursTotalPrice +
            getters.toursTotalInsurance +
            getters.accessoriesTotalPrice +
            getters.merchandisesTotalPrice +
            getters.additionalOptionsTotalPrice;
    },
    totalTax: (state, getters) => {
        return Math.ceil(getters.bikesTax +
            getters.eventBikesTax +
            getters.toursTax +
            getters.accessoriesTax +
            getters.merchandisesTax +
            getters.additionalOptionsTax);
    },
    promoCode: (state) => {
        return state.promoCode;
    },
    totalDiscount: (state, getters) => {
        if (state.promoCode) {
            switch (state.promoCode.mode) {
                case PROMO_CODE_MODE.PERCENTAGE:
                    return getters.totalPrice * state.promoCode.amount;
                case PROMO_CODE_MODE.AMOUNT:
                    return state.promoCode.amount;
                default:
                    return 0;
            }
        }
        return 0;
    }
}

export default {
    strict: true,
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
